import { render } from "./EventInspection.vue?vue&type=template&id=47aed1ff&ts=true"
import script from "./EventInspection.vue?vue&type=script&lang=ts"
export * from "./EventInspection.vue?vue&type=script&lang=ts"

import "./EventInspection.vue?vue&type=style&index=0&id=47aed1ff&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__